import { useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import Button from '@eduzz/houston-ui/Button';

import { Container } from './styles';

export const BtnReturn = () => {
  const navigate = useNavigate();

  const handleClickBackButton = useCallback(() => {
    navigate('/orderbump', { replace: true });
  }, [navigate]);
  return (
    <Container>
      <Button onClick={handleClickBackButton}>Voltar para a home</Button>
    </Container>
  );
};
